import { request } from '@/api/httpClient'
import { ContractType, RequestType } from '@/enums'

export async function kpiDashboardQuotes(range) {
  return request({
    method: 'kpi/NumberOfContracts',
    payload: {
      Range: Number(range),
      Type: Number(ContractType.QUOTE)
    }
  })
}

export async function kpiDashboardOrders(range) {
  return request({
    method: 'kpi/NumberOfContracts',
    payload: {
      Range: Number(range),
      Type: Number(ContractType.ORDER)
    }
  })
}

export async function kpiGetCustomerStatus() {
  return request({
    method: 'kpi/CustomerStatus',
    requestType: RequestType.GET
  })
}

export async function kpiGetCustomerActivity({ period, count, sort, descending }) {
  return request({
    method: `kpi/CustomerActivity?period=${period}&count=${count}&sort=${sort}&descending=${descending}`,
    requestType: RequestType.GET
  })
}

export async function kpiGetCustomerActivityDetail({ customerId, period }) {
  return request({
    method: `kpi/CustomerActivity/Detail?customerId=${customerId}&period=${period}`,
    requestType: RequestType.GET
  })
}
